import { render, staticRenderFns } from "./data_sync_section.vue?vue&type=template&id=6f34d314&scoped=true&"
import script from "./data_sync_section.vue?vue&type=script&lang=js&"
export * from "./data_sync_section.vue?vue&type=script&lang=js&"
import style0 from "./data_sync_section.vue?vue&type=style&index=0&id=6f34d314&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f34d314",
  null
  
)

export default component.exports